export const ProductionSimulationMeal = (json: IProductionSimulationMeal): IProductionSimulationMealModel => {
	const {
		created_at,
		updated_at,
		production_meal,
		production_meal_id,
		production_simulation_id,
		production_started,
		...rest
	} = json

	return {
		...rest,
		productionStarted: production_started ?? false,
		productionMeal: ProductionPlanDetailsMeal(production_meal),
		productionMealID: production_meal_id,
		productionSimulationID: production_simulation_id,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}
